import { render, staticRenderFns } from "./W9Upload.vue?vue&type=template&id=b4316e48&scoped=true&"
import script from "./W9Upload.vue?vue&type=script&lang=js&"
export * from "./W9Upload.vue?vue&type=script&lang=js&"
import style0 from "./W9Upload.vue?vue&type=style&index=0&id=b4316e48&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4316e48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
